import getBrandingLinkClickProps from "selectors/navigation/getBrandingLinkClickProps";
import getFontSizeIconLarge from "selectors/styles/getFontSizeIconLarge";
import MonogramIcon from "Navigation/components/MonogramIcon";
import PropTypes from "prop-types";
import React from "react";
import { AnalyticsActions } from "utils/Analytics";
import { connect } from "react-redux";
import { Link } from "react-router";
import get from "lodash/get";
import isUndefined from "lodash/isUndefined";
import styles from "./StoryTitleMonogramBlock.css";

function StoryTitleMonogramBlock(props) {
  const monogramIcon =
    props.hideLogo || !props.hasCustomMonogram ? null : (
      <div className="nav__monogram">
        <MonogramIcon
          height={props.monogramHeight}
          logoBorderRadiusPercent={props.logoBorderRadiusPercent}
          logoContent={props.logoContent}
          logoOpacity={props.logoOpacity}
          transitionEffects={props.monogramTransitionEffects}
        />
      </div>
    );

  if (props.showBackButton) {
    return null;
  }
  if (!props.openInNewWindow) {
    return (
      <div className={styles.root}>
        <Link
          className={styles.clickContainer}
          onClick={props.onClick}
          to={props.url}
        >
          {monogramIcon}
        </Link>
      </div>
    );
  }
  return (
    <div className={styles.root}>
      <a
        className={styles.clickContainer}
        href={props.url}
        onClick={props.onClick}
        rel="noopener noreferrer"
        target="_blank"
      >
        {monogramIcon}
      </a>
    </div>
  );
}

StoryTitleMonogramBlock.propTypes = {
  hideLogo: PropTypes.bool,
  logoBorderRadiusPercent: PropTypes.number,
  logoContent: PropTypes.string.isRequired,
  logoOpacity: PropTypes.number,
  monogramHeight: PropTypes.number.isRequired,
  monogramTransitionEffects: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  openInNewWindow: PropTypes.bool.isRequired,
  showBackButton: PropTypes.bool.isRequired,
  showStoryTitle: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
  hasCustomMonogram: PropTypes.bool,
};

// Create redux-wrapped Navigation component instance
const connector = connect(
  (state, ownProps) => {
    const fontSizeIconLarge = getFontSizeIconLarge(state);
    const monogramHeight = fontSizeIconLarge * state.story.logoHeightMultiplier;

    if (!state.story.logoContent) {
      throw new Error("Need logo content");
    }

    const hideTitleAuthorValue = get(
      state,
      "story.customizations.playerNavigation.hideTitleAuthor",
    );
    const hideTitleAuthor = isUndefined(hideTitleAuthorValue)
      ? state.story.hasCustomMonogram
      : hideTitleAuthorValue;

    return {
      ...getBrandingLinkClickProps(state, ownProps),
      logoOpacity: state.story.logoOpacity,
      logoContent: state.story.logoContent,
      hideLogo: state.story.hideLogo,
      hasCustomMonogram: state.story.hasCustomMonogram,
      logoBorderRadiusPercent: state.story.logoBorderRadiusPercent,
      monogramHeight,
      monogramTransitionEffects: true,
      showStoryTitle: !hideTitleAuthor && !ownProps.showBackButton,
    };
  },
  () => ({
    onClick: AnalyticsActions.verseLogoButtonClick,
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    onClick() {
      if (stateProps.openInNewWindow) {
        window.VersePlayer.pause();
      }

      dispatchProps.onClick();
    },
  }),
);

export default connector(StoryTitleMonogramBlock);
